// extracted by mini-css-extract-plugin
module.exports = {"boardColumn":"boardColumn_boardColumn__6ss15"};